/* unplugin-vue-components disabled */import { render } from "./users-ddown.vue?vue&type=template&id=0b7f92a7&scoped=true"
import script from "./users-ddown.vue?vue&type=script&lang=js"
export * from "./users-ddown.vue?vue&type=script&lang=js"

import "./users-ddown.vue?vue&type=style&index=0&id=0b7f92a7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7f92a7"],['__file',"src/pages/tenants/users-ddown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b7f92a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b7f92a7', __exports__)) {
    api.reload('0b7f92a7', __exports__)
  }
  
  module.hot.accept("./users-ddown.vue?vue&type=template&id=0b7f92a7&scoped=true", () => {
    api.rerender('0b7f92a7', render)
  })

}


export default __exports__